import { Table } from '@vwfs-bronson/bronson-react';
import { GitHubRepository, UnclaimedInstallation } from '../fes';

function formatRepositories(repositories: GitHubRepository[] | undefined): string {
  if (!repositories || repositories.length === 0) {
    return '-';
  }

  return repositories
    .map(repository => {
      const details = [
        `id: ${repository.id}`,
        `name: ${repository.name}`,
        `visibility: ${repository.private ? 'private' : 'public'}`,
        repository.node_id ? `node: ${repository.node_id}` : undefined,
      ].filter(Boolean);

      return `${repository.full_name} (${details.join(', ')})`;
    })
    .join('; ');
}

export function GitHubAppsTable({ installations }: { installations: UnclaimedInstallation[] }) {
  if (installations.length === 0) {
    return <p className="app-empty">No unclaimed installations found.</p>;
  }

  return (
    <div className="app-table-wrap">
      <Table className="app-table" colored>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Installation ID</Table.Th>
            <Table.Th>Account Login</Table.Th>
            <Table.Th>Account ID</Table.Th>
            <Table.Th>Account Type</Table.Th>
            <Table.Th>Repositories</Table.Th>
            <Table.Th>Created At</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {installations.map(installation => (
            <Table.Tr key={installation.installationId}>
              <Table.Td>{installation.installationId}</Table.Td>
              <Table.Td>{installation.accountLogin}</Table.Td>
              <Table.Td>{installation.accountId}</Table.Td>
              <Table.Td>{installation.accountType || '-'}</Table.Td>
              <Table.Td>{formatRepositories(installation.repositories)}</Table.Td>
              <Table.Td>{installation.createdAt || '-'}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
